import { Toolbar } from '@mui/material'
import React from 'react'

import { ConnectionBox } from '../Components'
import { AllowanceBalance, HeaderMenu, IconArea } from './Components'

interface Props {
  geotokensAllowance?: boolean
}

const SystemToolbar: React.FC<Props> = (props) => {
  const { geotokensAllowance } = props
  return (
    <Toolbar disableGutters>
      <ConnectionBox>
        <AllowanceBalance geotokensAllowance={geotokensAllowance} />
      </ConnectionBox>
      <IconArea />
      <HeaderMenu />
    </Toolbar>
  )
}

export default SystemToolbar
